import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Input } from '@angular/core';

import { EnclosureTypesNamesConstants } from '../../constants/enclosure-types-names.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-product-range-name',
    templateUrl: './product-range-name.component.html',
    styleUrls: ['./product-range-name.component.scss'],
    standalone: false
})
export class ProductRangeNameComponent {
  @Input() name: string;
  enclosureTypeConstants = EnclosureTypesNamesConstants;
}
